import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/svgs/logo.svg';
const _hoisted_1 = {
  class: "nav-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [_createElementVNode("div", {
    class: "nav-fixed"
  }, [_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })], -1)]));
}